<template>
	<a :href="item.link" class="c-card">
		<h3 class="c-card__title h-display--light h-display--one">{{item.title}}</h3>
		<span class="c-card__posttitle h-text--small" v-if="item.postTitle">{{item.postTitle}}</span>

		<div class="c-card__image">
			<div class="o-image" :style="{paddingTop:item.ratio * 100 + '%'}">
				<img class="o-image__full" :class="{'isLoaded':item.url}"
					v-bind:src="item.url" v-if="loaded"/>
				<div class="o-image__preview"  v-bind:style="{backgroundImage : 'url('+ item.preview.url +')'}"></div>
			</div>
		</div>

		<p class="c-card__summary" v-if="item.summary">{{item.summary}}</p>

	</a>
</template>

<script>
	import axios from 'axios';
	import imagesLoaded from 'vue-images-loaded'

  export default {
		name: 'v-card',
		data: function () {
			return {
				loaded : false
			}
		},
		props: {
			item: {
				type: Object
			},
		},
		methods: {
			getImageUrl() {
				var url = '/api/imager.json?id='+ this.item.imageId +'&width=580&height=580&type=fit'
				var self = this;

				axios.get(url, { crossdomain: true })
				.then((response) => {
					self.item.url = response.data.data[0].url;
					self.item.ratio = response.data.data[0].ratio;
					self.loaded = true
				})

			},
		},
		mounted() {
			this.getImageUrl()
		},
  }
</script>



// WEBPACK FOOTER //
// card.vue?a62e738c